import { 
  Home, 
  MessageCircle, 
  Heart, 
  Bell,
  User,
  Shield,
  Headphones,
  Crown,
  CreditCard,
  Target,
  Sparkles,
  LucideIcon
} from 'lucide-react';

export interface NavItem {
  icon: LucideIcon;
  label: string;
  path: string;
  description: string;
  badgeKey?: 'messages' | 'notifications';
}

export const baseNavItems: NavItem[] = [
  { 
    icon: Home, 
    label: 'Feed', 
    path: '/main/feed',
    description: 'Descobrir perfis'
  },
  { 
    icon: MessageCircle, 
    label: 'Chats', 
    path: '/main/chats',
    description: 'Suas mensagens',
    badgeKey: 'messages'
  },
  { 
    icon: Heart, 
    label: 'Likes', 
    path: '/main/connections',
    description: 'Suas curtidas'
  },
  { 
    icon: Bell, 
    label: 'Notificações', 
    path: '/main/notifications',
    description: 'Suas atualizações',
    badgeKey: 'notifications'
  },
  { 
    icon: Target, 
    label: 'Missões', 
    path: '/main/missions',
    description: 'Suas missões ativas'
  },
  { 
    icon: Sparkles, 
    label: 'Roleta', 
    path: '/main/wheel',
    description: 'Roleta da Sorte'
  },
  { 
    icon: User, 
    label: 'Perfil', 
    path: '/main/profile',
    description: 'Editar perfil'
  },
  {
    icon: CreditCard,
    label: 'Assinaturas',
    path: '/main/subscriptions',
    description: 'Gerenciar assinaturas'
  },
  { 
    icon: Shield, 
    label: 'Verificação', 
    path: '/main/verify',
    description: 'Verificar identidade'
  },
  { 
    icon: Headphones, 
    label: 'Suporte', 
    path: '/main/support',
    description: 'Central de ajuda'
  },
  {
    icon: Crown,
    label: 'Painel Admin',
    path: '/main/joia/admin',
    description: 'Controle da plataforma'
  }
];

export const getNavItemByPath = (path: string): NavItem | undefined => {
  // Exact match first
  const exactMatch = baseNavItems.find(item => item.path === path);
  if (exactMatch) return exactMatch;
  
  // For chat routes, match /main/chats for /main/chat/:id
  if (path.startsWith('/main/chat/')) {
    return baseNavItems.find(item => item.path === '/main/chats');
  }
  
  // Partial match (path starts with item.path)
  return baseNavItems.find(item => path.startsWith(item.path));
};
